<template>
  <div ref="container">

  </div>
</template>
<script>
  export default {
    name: 'mw-userfiled-selection',
    props: {
      value: {
        type: String,
        default: ''
      },
      params:{
        type:Object,
        default:{}
      }
    },
    data(){
      return {

      }
    },
    mounted() {
      let me=this;
      $WR.ready(function (manager) {
        manager.create({
          xtype: 'UserFieldSelectionComp',
          isFormField: false
        }, function(obj) {
          let pageData=obj.getPageData();
          pageData.params=me.params;
          let component=PF.createVue(pageData);
          $(me.$el).append(component.$mount().$el);
          component.$on("select",function (v) {
                me.$emit("select",v);
          })
          me.$obj=obj;
        })
      });
    },
    methods: {
      getValue() {
        return this.$obj.getValue();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/user-filed-selection/index.vue